export default {
    name: 'graph',
    apiNDMIUrl: '/graph/ndmi/',
    apiNDVIUrl: '/graph/ndvi/',
    apiSWIUrl: '/graph/swi/'
};
